/**
 * For memoized.
 * Like `react hooks`.
 */
export function passThrough<T>(param: T) {
	return param;
}
